import { createGlobalStyle } from 'styled-components';

export const themeIsDark = (): boolean => {
  const explicit = document.documentElement.getAttribute('data-theme');
  if (explicit === 'dark') return true;
  if (explicit === 'light') return false;
  return window.matchMedia('(prefers-color-scheme: dark)').matches;
};

export const LIGHT_THEME = {
  textSelection: 'rgba(28, 117, 188, 0.25)',
  primary: '#1c75bc',
  primaryBackground: '#165a8c',
  primaryUnderline: 'rgba(28, 117, 188, 0.5)',
  primaryHover: '#124e7a',
  primaryHoverBackground: '#124e7a',
  primaryFocus: 'rgba(28, 117, 188, 0.25)',
  primaryInverse: '#fff',
} as const;

export const DARK_THEME: Record<keyof typeof LIGHT_THEME, string> = {
  textSelection: 'rgba(41, 137, 216, 0.1875)',
  primary: '#2989d8',
  primaryBackground: '#165a8c',
  primaryUnderline: 'rgba(41, 137, 216, 0.5)',
  primaryHover: '#4fa6e6',
  primaryHoverBackground: '#1c75bc',
  primaryFocus: 'rgba(41, 137, 216, 0.25)',
  primaryInverse: '#fff',
} as const;

export const getThemeValue = (key: keyof typeof LIGHT_THEME): string => {
  const isDark = themeIsDark();
  const theme = isDark ? DARK_THEME : LIGHT_THEME;

  return theme[key];
};

export const Theme = createGlobalStyle`
  [data-theme="light"],
  :root:not([data-theme="dark"]) {
    --pico-text-selection-color: ${LIGHT_THEME.textSelection};
    --pico-primary: ${LIGHT_THEME.primary};
    --pico-primary-background: ${LIGHT_THEME.primaryBackground};
    --pico-primary-underline: ${LIGHT_THEME.primaryUnderline};
    --pico-primary-hover: ${LIGHT_THEME.primaryHover};
    --pico-primary-hover-background: ${LIGHT_THEME.primaryHoverBackground};
    --pico-primary-focus: ${LIGHT_THEME.primaryFocus};
    --pico-primary-inverse: ${LIGHT_THEME.primaryInverse};
  }

  @media (prefers-color-scheme: dark) {
    :root:not([data-theme]) {
      --pico-text-selection-color: ${DARK_THEME.textSelection};
      --pico-primary: ${DARK_THEME.primary};
      --pico-primary-background: ${DARK_THEME.primaryBackground};
      --pico-primary-underline: ${DARK_THEME.primaryUnderline};
      --pico-primary-hover: ${DARK_THEME.primaryHover};
      --pico-primary-hover-background: ${DARK_THEME.primaryHoverBackground};
      --pico-primary-focus: ${DARK_THEME.primaryFocus};
      --pico-primary-inverse: ${DARK_THEME.primaryInverse};
    }
  }

  [data-theme="dark"] {
    --pico-text-selection-color: ${DARK_THEME.textSelection};
    --pico-primary: ${DARK_THEME.primary};
    --pico-primary-background: ${DARK_THEME.primaryBackground};
    --pico-primary-underline: ${DARK_THEME.primaryUnderline};
    --pico-primary-hover: ${DARK_THEME.primaryHover};
    --pico-primary-hover-background: ${DARK_THEME.primaryHoverBackground};
    --pico-primary-focus: ${DARK_THEME.primaryFocus};
    --pico-primary-inverse: ${DARK_THEME.primaryInverse};
  }

  .pico [role="group"] {
    margin-bottom: unset;
  }
`;
